import { Field, ID, ObjectType } from '@warebee/shared/util-backend-only-types';

@ObjectType()
export class BatchPicklistsJobOrderLineRuleSummary {
  @Field(() => ID)
  orderLineRuleId: string;

  @Field()
  initialPicklistCount: number;

  @Field()
  batchedPicklistCount: number;

  @Field()
  batchImprovement: number;
}

@ObjectType()
export class BatchPicklistsJobSummary {
  @Field()
  initialPicklistCount: number;

  @Field()
  batchedPicklistCount: number;

  @Field()
  batchImprovement: number;

  @Field(() => [BatchPicklistsJobOrderLineRuleSummary])
  orderLineRules: BatchPicklistsJobOrderLineRuleSummary[];
}
